import { Modifier, AtomicBlockUtils, EditorState } from "draft-js";


/**
 * @param {DraftEditorStore} store
 */
export function insertVideo(store, { videoId, videoPlatform }) {
	const editorState = store.getEditorState();
	const content = editorState.getCurrentContent();
	const name = '视频内容';
	const entityData = {
		name,
		videoPlatform,
		videoId,
	};
	const contentWithEntity = content.createEntity('VIDEO', 'IMMUTABLE', entityData);
	const entityKey = contentWithEntity.getLastCreatedEntityKey();

	store.setEditorState(
		AtomicBlockUtils.insertAtomicBlock(
			EditorState.set(editorState, {
				currentContent: contentWithEntity,
			}),
			entityKey,
			name,
		)
	);
}



// WEBPACK FOOTER //
// ./lib/helpers/insertVideo.js